import {Stack, StackProps} from '../Stack/Stack';

export type VStackProps = Omit<StackProps, 'direction'>;

/**
 * VStack - Vertical stack component
 * Wrapper around Stack with direction="column"
 * @example
 * <VStack spacing={4}>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </VStack>
 */
export const VStack = (props: VStackProps) => {
  return <Stack {...props} direction="column" />;
};
